import u from 'umbrellajs';
import { createVariablesInDocument, stripTagsFromHTML2 } from './utils';
import { setContentGrapesJSComponent } from './domUtils';

// Menu text changed on the right will update the left menu and top menu
const handleSectionTitleChanged = component => {
	console.log(component.getClasses());
	if (component.getClasses().includes('header')) {
		const textContent = component.get('content');
		const parentSection = component.closest('div[id*="section-"]');
		if (parentSection) {
			const sectionId = `#${parentSection.getId()}`;
			const strippedText = stripTagsFromHTML2(textContent);
			u(`.each-section-title a[data-section-id="${sectionId}"]`).text(strippedText);
			setContentGrapesJSComponent(`a[href="${sectionId}"]`, strippedText);
		}
	}
};

export const handleComponentDeselected = component => {
	console.log('handleComponentDeselected', component);
	handleSectionTitleChanged(component);
};

export const doInComponentUpdate = (editor, component) => {
	if (component.is('image')) {
		const view = component.getView();
		const { className } = view.el;
		// console.log('doInComponentUpdate className', className, component._changing);
		if (className.startsWith('dummy-image') && component._changing) {
			const { src } = component.changed;
			if (src) {
				window.GM_BACKGROUND_IMAGE_URL = `${src}&h=4000&w=4000`;
				createVariablesInDocument();
			}
		}
	}
};
